Array.prototype.getBy = function(key, val)
{
    for(let i = 0; i < this.length; ++i)
    {
        if (this[i][key] == val)
            return this[i]
    }
    return {}
}



// WEBPACK FOOTER //
// ./src/plugins/helpers.js